import type { Dictionnaire } from '../type';

export const moderation: Dictionnaire['moderation'] = {
  erreurs: {
    compteOfficiel: "The app's account can't be reported. Write to it with any question.",
  },
  contenu: {
    supprime: '(content deleted)',
    sansTexte: '(no text)',
  },
  merci: {
    emailParti: 'If an account exists, an email is on its way.',
    post: "Thanks, our team will look into it. You won't see this post anymore.",
    signalement: "Report sent. Thanks, we'll look into it.",
    sortie: "Thanks, our team will look into it. You won't see this event anymore.",
    simple: 'Thanks, our team will look into it.',
    membre: 'Thanks, our team will look into it. This member is blocked in the meantime.',
    support: 'Message sent. Our team will reply by email.',
  },
  raisons: {
    spam: 'Spam',
    harassment: 'Harassment',
    shocking: 'Shocking content',
    misinformation: 'False information',
    other: 'Other',
  },
  admin: {
    durees: {
      jour: '24 hours',
      semaine: '7 days',
      mois: '30 days',
      sansTerme: 'No end date',
    },
    echec: "That didn't work.",
    fait: (geste: string) => `${geste}: done.`,
    gestes: {
      avertir: 'Warn',
      liberer: 'Give back their voice',
      museler: 'Mute',
      retablir: 'Restore the account',
      suspendre: 'Suspend the account',
      suspendreQ: 'Suspend this account?',
      retirerCoche: 'Remove the badge',
      poserCoche: 'Add the badge',
      nommerModerateur: 'Make moderator',
      nommerAdmin: 'Make admin',
      retirerRole: 'Remove the role',
      supprimer: 'Delete the account',
      supprimerQ: 'Erase this account and everything it wrote? Nothing will bring it back.',
    },
    titre: 'Administration',
    chercherMembre: 'Search for a member',
    sonPseudo: 'Their username',
    chercher: 'Search',
    personne: 'No one with this username',
    autre: '← Search for someone else',
    rien: 'Nothing to report',
    avertissements: 'Warnings',
    texteMembre: 'What the member will read',
    pourquoi: 'Why (kept in the log)',
    etat: {
    administrateur: 'admin',
    moderateur: 'moderator',
    verifie: 'verified',
    suspendu: 'suspended',
    muetJusqua: (date: string) => `muted until ${date}`,
    muet: 'muted, no end date',
    signalements: (n: number) => `${n} reports`,
    avertissements: (n: number) => `${n} warnings`,
    lu: 'read',
    pasLu: 'not read yet',
  },
  },
  avertissement: {
    titre: 'Warning',
    compris: 'Got it',
  },
  file: {
    onglets: {
      ouverts: 'To handle',
      traites: 'Handled',
      tout: 'All',
    },
    natures: {
      post: 'Post',
      comment: 'Comment',
      event: 'Event',
      user: 'Member',
      conversation: 'Conversation',
      help: 'Help message',
    },
    masque: 'Content hidden.',
    suspendu: 'Member suspended.',
    classe: 'Report closed.',
    titre: 'Moderation',
    masquer: 'Hide the content',
    suspendre: 'Suspend the member',
    classer: 'Close without action',
    rienATraiter: 'Nothing to handle',
    rienIci: 'Nothing here',
    aucunEnAttente: 'No pending reports. That’s a good sign.',
    traitesIci: 'Handled reports will appear here.',
    etatMasque: 'Content hidden',
    etatSuspendu: 'Member suspended',
    etatClasse: 'Closed without action',
    traiter: 'Handle',
    suspendreQ: (nom: string) => `Suspend ${nom}? Their access is cut off until restored.`,
    signalements: (n: number) => `${n} reports`,
    signalePar: (nom: string) => `reported by ${nom}`,
  },
  signaler: {
    quoi: {
      post: 'this post',
      comment: 'this reply',
      event: 'this event',
      member: 'this member',
      conversation: 'this conversation',
    },
    impossible: "Couldn't send right now.",
    titre: 'Report',
    indisponible: 'This content is no longer available.',
    envoyer: 'Send',
    motif: 'What is the reason?',
    detail: 'Add details if you want',
    detailExemple: 'Optional: what happened, and since when.',
    intro: (quoi: string) =>
    `Tell us what's wrong with ${quoi}. Our team reviews every report, and the person concerned isn't notified.`,
  },
};
